import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxPermissionsModule } from 'ngx-permissions';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { ToastModule } from 'primeng/toast';
import { ShopAntifraudLimitsComponent } from './shop-antifraud-limits/shop-antifraud-limits.component';
import { ShopSettingsRoutingModule } from './shop-settings-routing.module';

@NgModule({
  declarations: [ShopAntifraudLimitsComponent],
  imports: [
    CommonModule,
    ShopSettingsRoutingModule,
    ReactiveFormsModule,
    ButtonModule,
    InputTextModule,
    InputNumberModule,
    InputSwitchModule,
    ToastModule,
    NgxPermissionsModule.forChild()
  ],
  providers: [MessageService]
})
export class ShopSettingsModule {}
